import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_radio_group, {
      value: _ctx.innerValue,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerValue) = $event)),
      disabled: _ctx.disabled,
      onChange: _ctx.onChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_radio, { value: "1" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.trueText), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_radio, { value: "0" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.falseText), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "disabled", "onChange"])
  ]))
}